import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";

export default function VerifyPage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/payments/emailVerification${location.search}`);
  }, []);

  return(
    <div></div>
  );
}
